import { get } from 'lodash';

export const AUTH_TOKEN_UPDATED_EVENT = 'qwiky:auth-token-updated';
export const AUTH_TOKEN_BROADCAST_CHANNEL = 'qwiky-auth-token';
export const AUTH_TOKEN_UPDATED_MESSAGE = 'AUTH_TOKEN_UPDATED';
export const AUTH_TOKEN_REFRESH_REQUIRED_MESSAGE = 'AUTH_TOKEN_REFRESH_REQUIRED';

let authChannel;
let workerRefreshHandler;

const getAuthChannel = () => {
  if (authChannel || typeof window === 'undefined' || !window.BroadcastChannel) {
    return authChannel;
  }

  authChannel = new window.BroadcastChannel(AUTH_TOKEN_BROADCAST_CHANNEL);
  authChannel.onmessage = async ({ data = {} }) => {
    if (data.type !== AUTH_TOKEN_REFRESH_REQUIRED_MESSAGE || !workerRefreshHandler) return;

    try {
      await workerRefreshHandler(data);
    } catch (error) {
      // The API client owns terminal refresh/logout handling. This log keeps worker
      // polling failures observable without dispatching a second UI error.
      console.error('[Auth][Polling] Unable to refresh polling credentials', error);
    }
  };
  return authChannel;
};

export const notifyAuthTokenUpdated = (authData = {}) => {
  const accessToken = get(authData, 'accessToken', '');
  if (!accessToken || typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent(AUTH_TOKEN_UPDATED_EVENT, { detail: { authData, accessToken } }),
  );
  const channel = getAuthChannel();
  if (channel) channel.postMessage({ type: AUTH_TOKEN_UPDATED_MESSAGE, accessToken });
};

export const registerWorkerTokenRefreshHandler = (handler) => {
  workerRefreshHandler = handler;
  getAuthChannel();

  return () => {
    if (workerRefreshHandler === handler) workerRefreshHandler = undefined;
  };
};
